export function formateDateTime(dateTime, localeCode) {
  return new Date(dateTime).toLocaleString(localeCode);
}
